"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_MIN_ABS_DOMAIN = exports.ScaleType = void 0;
exports.ScaleType = Object.freeze({
    LinearBinary: 'linear_binary',
    Linear: 'linear',
    Ordinal: 'ordinal',
    Log: 'log',
    Sqrt: 'sqrt',
    Time: 'time',
    Quantize: 'quantize',
    Quantile: 'quantile',
    Threshold: 'threshold',
});
exports.LOG_MIN_ABS_DOMAIN = 1;
//# sourceMappingURL=constants.js.map